<template>
  <div v-if="about">
    <div id="menu">
      <div class="menuItem link" id="menuLaureats" :class="{ open: laureats }">
        <span class="italic" @click="showL()">Lauréat·e·s</span>
        <div class="subMenu">
          &nbsp;: <router-link to="/laureats/annees">Années</router-link>, <router-link to="/laureats/abc">ABC</router-link>, <router-link to="/laureats/domaine">Domaine</router-link>,
          <router-link to="/laureats/prix">Prix</router-link>, <router-link to="/laureats/videos">Vidéos</router-link>,
          <router-link to="/laureats/rechercher">Rechercher</router-link>
        </div>
      </div>

      <div class="spacer">•</div>

      <div class="menuItem link" id="menuPropos" :class="{ open: propos, nAbout: !about.ceremony }">
        <span class="italic" @click="showA()">À propos</span>
        <div class="subMenu">
          &nbsp;: <router-link v-if="about.ceremony" to="/about/ceremonie">Cérémonie</router-link><span v-if="about.ceremony">, </span> <router-link to="/about/mission">Mission</router-link>,
          <router-link to="/about/fondation">Conseil de fondation</router-link>,
          <router-link to="/about/partenaires">Partenaires</router-link>
        </div>
      </div>

      <div class="spacer">•</div>

      <div class="menuItem" id="menuContact">
        <router-link to="/contact">Contact</router-link>
      </div>

      <div class="spacer">•</div>

      <div class="menuItem" id="menuInv">
        <router-link to="/ceremonie">Cérémonie</router-link>
      </div>
    </div>

    <div id="mobMenu" :class="{ mobmen: mobmen, openSub: laureats || propos }">
      <div id="menus">
        <div class="mobLogo mobL1">
          <div id="mobLogo" :style="{ transform: 'translate3d(0,0,0) rotate(' + logo + 'deg)' }">
            <Logo />
          </div>
        </div>

        <div class="mobL1 mobflex">
          <span class="italic" @click="showL()" :class="{ open: laureats }">Lauréats</span>
        </div>

        <div class="mobSub" :class="{ open: laureats }">
          <router-link @click.native="goToRoute($event, '/laureats/annees')" event="" to="/laureats/annees">Années</router-link>
          <router-link @click.native="goToRoute($event, '/laureats/abc')" event="" to="/laureats/annees">ABC</router-link>
          <router-link @click.native="goToRoute($event, '/laureats/domaine')" event="" to="/laureats/domaine">Domaine</router-link>
          <router-link @click.native="goToRoute($event, '/laureats/prix')" event="" to="/laureats/prix">Prix</router-link>
          <router-link @click.native="goToRoute($event, '/laureats/videos')" event="" to="/laureats/videos">Vidéos</router-link>
          <router-link @click.native="goToRoute($event, '/laureats/rechercher')" event="" to="/laureats/rechercher">Rechercher</router-link>
        </div>

        <div class="mobL1 mobflex">
          <span class="italic" @click="showA()" :class="{ open: propos }">À propos</span>
        </div>

        <div class="mobSub" :class="{ open: propos }">
          <router-link v-if="about.ceremony" @click.native="goToRoute($event, '/about/ceremonie')" event="" to="/about/ceremonie">Cérémonie</router-link>
          <router-link @click.native="goToRoute($event, '/about/mission')" event="" to="/about/mission">Mission</router-link>
          <router-link @click.native="goToRoute($event, '/about/fondation')" event="" to="/about/fondation">Conseil de fondation</router-link>
          <router-link @click.native="goToRoute($event, '/about/partenaires')" event="" to="/about/partenaires">Partenaires</router-link>
        </div>

        <div class="mobL1 mobflex"><router-link @click.native="goToRoute($event, '/contact')" event="" to="/contact">Contact</router-link></div>
        <div class="mobL1 mobflex"><router-link @click.native="goToRoute($event, '/ceremonie')" event="" to="/ceremonie">Cérémonie</router-link></div>
      </div>

      <div id="mobBottom">
        <div id="currentPage" v-html="currentName"></div>

        <div id="openMob" @click="openMobMenu">
          <div id="burger" v-if="!mobmen">
            <div></div>
            <div></div>
            <div></div>
          </div>

          <div id="closeBurger" v-else>&times;</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/assets/images/Logo';

export default {
  data() {
    return {
      logo: 0,
      mobmen: false,
      laureats: false,
      propos: false,
      to: false,
    };
  },

  components: {
    Logo,
  },

  methods: {
    goToRoute(e, route) {
      this.mobmen = false;
      this.$store.commit('editState', { state: 'mobOpen', data: this.mobmen });

      setTimeout(() => this.$router.push(route), 500);
    },

    openMobMenu() {
      this.mobmen = !this.mobmen;
      if (this.mobmen) this.loop();
      this.$store.commit('editState', { state: 'mobOpen', data: this.mobmen });
    },

    loop() {
      this.logo = this.logo + 0.5 <= 360 ? this.logo + 0.5 : 0;
      if (this.mobmen) requestAnimationFrame(this.loop);
    },

    showL() {
      this.laureats = !this.laureats;
      this.propos = false;
      this.to = 'laureats';
    },

    showA() {
      this.propos = !this.propos;
      this.laureats = false;
      this.to = 'about';
    },

    setMenu(to) {
      if (to === 'about') this.propos = true;
      if (to === 'laureats') this.laureats = true;
    },
  },

  computed: {
    about() {
      return this.$store.getters.about;
    },

    currentName() {
      let cName;

      if (this.$route.name === 'invitation') {
        cName = 'Invitation';
      }

      if (this.$route.name === 'contact') {
        cName = 'Contact';
      }

      if (this.$route.name === 'about') {
        cName = 'À propos';
      }

      if (this.$route.name === 'laureats-laureat' || this.$route.name === 'laureats' || this.$route.name === 'laureat' || this.$route.name === 'current') {
        cName = 'Laureats';
      }

      return cName;
    },
  },

  mounted() {
    this.loop();
    this.setMenu(this.$route.name);
  },

  watch: {
    '$store.state.mobOpen'(val) {
      if (!val) {
        this.mobmen = false;
      }
    },

    $route(to, from) {
      if (this.mobmen) this.openMobMenu();

      this.setMenu(to.name);

      if (to.name !== 'about' && to.name !== 'laureats' && to.name !== 'laureats-laureat') {
        this.propos = false;
        this.laureats = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';

.page-splash {
  #mobMenu,
  #menu {
    display: none;
  }
}

#menu {
  z-index: 5;
  background-color: white;
  border-top: $line;
  position: fixed;
  bottom: 0;
  left: 0;
  height: $menu;
  width: 100%;
  display: flex;
  font-size: $mediumtype;
  line-height: 3rem;
  transition: opacity $ease ease;
  align-items: center;
  justify-content: center;

  a:hover {
    font-style: italic;
  }
}

.open .italic,
.open.italic,
#menu .router-link-active,
#mobMenu .router-link-active,
.italic:hover {
  font-style: italic;
}

.spacer {
  width: 3rem;
  text-align: center;
  padding-right: 0.2rem;
}

.subMenu {
  display: inline-block;
  opacity: 0;
  transition: opacity $ease ease;
  display: none;
}

.italic {
  cursor: pointer;
}

.menuItem {
  transition: width $ease ease;
  overflow: hidden;
  white-space: nowrap;
}

#menuLaureats {
  width: 9.2%;

  &.open {
    width: 52.5%;
  }
}

#menuPropos {
  width: 7.8%;

  &.open {
    width: 55.3%;

    &.nAbout {
      width: 44.7%;
    }
  }
}

#menuContact {
  width: 6.9%;
}

.open {
  .subMenu {
    display: inline;
    opacity: 1;
  }
}

#mobMenu {
  display: none;
}

@media screen and (max-width: $breakPoint1) {
  #menu {
    display: none;
  }

  #mobMenu {
    display: flex;
  }

  #burger {
    cursor: pointer;
    width: 2rem;
    top: 0;

    div {
      border-bottom: 1px solid;
      height: 1px;
      width: 100%;
      margin: 0.7rem 0;
    }
  }

  #closeBurger {
    cursor: pointer;
    font-size: 4.5rem;
    padding-top: 0.5rem;
    margin-right: -0.3rem;
  }

  #openMob {
    position: absolute;
    padding: 0 2rem;
    right: 0;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #menus {
    position: fixed;
    bottom: $menu;
    left: 0;
    top: 100%;
    width: 100%;
    background-color: white;
    transition: top $ease ease, color $ease ease;
    display: flex;
    flex-direction: column;
    color: white;

    a {
      color: white;
    }
  }

  .mobOpen {
    #currentPage {
      opacity: 0;
    }

    #menus {
      .mobLogo {
        opacity: 1;
      }

      color: $maincolour;

      a {
        color: $maincolour;
      }
    }
  }

  .mobL1,
  .mobSub {
    transition: height $ease ease, border $ease ease, flex $ease ease, opacity $ease ease;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    white-space: nowrap;
    border-top: $line2;
    overflow: hidden;
  }

  .mobflex {
    flex-grow: 1;
  }

  .mobSub {
    flex: 0;
    border-top: 1px solid transparent;

    a {
      display: block;
      margin: 0.5rem 0;
    }

    &.open {
      border-top: $line2;
      flex-grow: 3;
    }

    height: 0;
    flex-direction: column;
  }

  #currentPage {
    opacity: 1;
    transition: opacity $ease ease;
  }

  .mobLogo {
    opacity: 0;
    overflow: hidden;
    height: calc(#{$moblogo} + 4rem);

    img {
      margin: 2rem 0;
      width: $moblogo;
      height: $moblogo;
    }
  }

  .openSub .mobLogo {
    height: 0;
  }

  .mobmen #menus {
    top: -2px;
  }

  #mobBottom {
    color: $maincolour;
    background-color: white;
    height: $menu;
    width: 100%;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 0;
    position: absolute;
    border-top: $line2;
  }

  #mobMenu {
    z-index: 5;
    cursor: default;
    background-color: white;
    border-top: $line2;
    position: fixed;
    bottom: 0;
    left: 0;
    height: $menu;
    width: 100%;
    display: flex;
    transition: opacity $ease ease;
    align-items: center;
    justify-content: center;

    a:hover {
      font-style: italic;
    }
  }
}
</style>
